import { z } from 'zod';
// ============================================================================
// Webhook event types
// ============================================================================
export const WebhookEventTypeSchema = z.enum([
    'event.scheduled',
    'event.reminder.sent',
    'event.confirmed',
    'campaign.completed',
    'contact.dnc.added',
    // Phase 3c.1 — public booking lifecycle.
    'booking.pending_approval',
    // Task #7 — KITE page-builder form submissions. One event type covers
    // every form on every page; the form's own `event_name` is included in
    // the payload `data.event_name` so receivers can route by it.
    'kite.form.submitted',
]);
// ============================================================================
// Webhook subscription
// ============================================================================
export const WebhookSchema = z.object({
    id: z.string().regex(/^whk_[A-Za-z0-9_-]+$/),
    customer_id: z.string().regex(/^cust_[A-Za-z0-9_-]+$/),
    url: z.string().url(),
    events: z.array(WebhookEventTypeSchema).min(1),
    active: z.boolean(),
    description: z.string().max(500).optional(),
    created_at: z.string().datetime(),
});
export const WebhookCreateSchema = z.object({
    url: z.string().url(),
    events: z.array(WebhookEventTypeSchema).min(1),
    description: z.string().max(500).optional(),
});
/**
 * Returned exactly once at creation time. The plaintext `secret` is used by
 * the receiver to verify HMAC signatures on inbound deliveries — it is not
 * persisted to the receiver via any subsequent API call.
 */
export const WebhookWithSecretSchema = WebhookSchema.extend({
    secret: z.string(),
});
// ============================================================================
// Event envelope (common to all event types)
// ============================================================================
export const WebhookEventEnvelopeSchema = z.object({
    id: z.string().min(1, 'event id required for receiver-side idempotency'),
    type: WebhookEventTypeSchema,
    created_at: z.string().datetime(),
    customer_id: z.string().regex(/^cust_[A-Za-z0-9_-]+$/),
    data: z.unknown(),
});
//# sourceMappingURL=webhooks.js.map